module.exports = __webpack_public_path__ + "static/media/online-screen-share.8ba52e3f.svg";